function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import TablesService from "@/apps/data-platform/services/tables_views/tables_service";
import { TYPSE_SENSE_TYPE_OBJECTS } from '@/js/constants';
export default {
  name: 'ItemTableViewComponent',
  props: {
    item: {
      type: Object,
      require: true
    },
    showView: {
      type: Boolean,
      default: true
    },
    showChange: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  computed: _objectSpread({}, mapState('data-platform', ['isSynapseAccessFunction', 'isBigqueryAccessFunction', 'orgs'])),
  data: function data() {
    return {
      aux: {},
      TYPSE_SENSE_TYPE_OBJECTS: TYPSE_SENSE_TYPE_OBJECTS
    };
  },
  mounted: function mounted() {},
  created: function created() {
    //console.log(this.item)
    //this.getBytes(this.item)
  },
  methods: {
    getBytes: function getBytes(item) {
      var _this = this;
      this.aux = {};
      var data = {
        "project_id": item.proyecto,
        "dataset_id": item.dataset,
        "table_id": item.titulo
      };
      TablesService.getBytes(data).then(function (response) {
        if (response.code === 200) {
          _this.aux = response.data;
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    similarityPercent: function similarityPercent(distance) {
      return Math.round((1 - distance) * 100);
    },
    similarityColor: function similarityColor(distance) {
      var pct = (1 - distance) * 100;
      if (pct >= 85) return 'success';
      if (pct >= 75) return 'warning';
      return 'error';
    },
    formatNumber: function formatNumber(number) {
      return number ? new Intl.NumberFormat('es-MX').format(number) : 0;
    },
    // Convierte un ISO (UTC u otro offset) a fecha/hora local del navegador
    formatLocalDate: function formatLocalDate(iso) {
      if (!iso) return '—';
      var d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleString();
    },
    formatBytes: function formatBytes(bytes) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      if (!+bytes) return '0 Bytes';
      var k = 1024;
      var dm = decimals < 0 ? 0 : decimals;
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), " ").concat(sizes[i]);
    },
    onVerObjeto: function onVerObjeto(item) {
      this.$emit("onVerObjeto", item);
    },
    onRequestObjeto: function onRequestObjeto(item) {
      this.$emit("onRequestObjeto", item);
    },
    onChangeObjeto: function onChangeObjeto(item) {
      this.$emit("onChangeObjeto", item);
    },
    check_access_function: function check_access_function(source, domain) {
      var key = 'has_' + source + '_access_function';
      var status = this.orgs.find(function (objeto) {
        return objeto.domain === domain;
      })[key];
      return status;
    }
  }
};